class StockChecker {

	constructor(stockCheckOutput) {
		this.outputElement = stockCheckOutput;
	}

	// Test with - 12600732352582
	getInventoryIdForVariant(variantElement) {
      var self = this;
      
      var variantId = variantElement.value;
      var productName = document.querySelector("h1").innerText;
      var variantName = productName;
      if (document.querySelector("variant-radios")) {
        variantName = productName +  " - " + document.querySelector("variant-radios").currentVariant.option1
      }
      self.outputElement.querySelector(".stock-variant-name").innerText = variantName;
      self.outputElement.querySelector(".stock-variant-name").classList.remove("hidden");

      const variantRadios = document.querySelector("variant-radios");
      var baseUrl = "https://api.slamcity.com/stockchecker/";
      var requestUrl = baseUrl + variantId;
      var variantRequest = new XMLHttpRequest();
      variantRequest.open('GET', requestUrl, true);

      self.outputElement.classList.remove("hidden");
      self.outputElement.querySelector(".stock-loading").classList.remove("hidden");
      self.outputElement.querySelector(".sold-out").classList.add("hidden");

      variantRequest.onload = function() {
        if (variantRequest.status == 200) {
          var variantData = JSON.parse(variantRequest.responseText);
          self.showStockLevelResponse(variantData.response, variantName);
        } else {
          self.showVariantError();
        }
      }

      variantRequest.onerror = function() {
        self.showVariantError();
      }

      variantRequest.send();
	}

	showStockLevelError() {
      self.outputElement.querySelector(".stock-error").classList.remove("hidden");
	}

	showVariantError() {
      self.outputElement.querySelector(".stock-error").classList.remove("hidden");
	}

	showStockLevelResponse(stockLevelData, variantName) {
      var self = this;

      self.outputElement.querySelector(".stock-loading").classList.add("hidden");
      self.outputElement.querySelector(".stock-error").classList.add("hidden");

	  var stockCount = stockLevelData.length;
      var outputArray = [];
	  var locationsToUse = this.locations;
      
      var outOfStock = Array.from(new Set(stockLevelData.map((loc) => {
        return loc.available;
      })));

      var eastStock = stockLevelData.filter((loc) => {
        if (loc.name.indexOf("East") > -1 || loc.name.indexOf("Brick") > -1) {
          return loc
        }
      }).map((loc) => loc.available);
      // console.log(eastStock)

      var oxfordStock = stockLevelData.filter((loc) => {
        if (loc.name.indexOf("North") > -1 || loc.name.indexOf("Oxford") > -1 || loc.name.indexOf("Didcot") > -1) {
          return loc.available
        }
      }).map((loc) => loc.available);
      // console.log(oxfordStock)
      
      self.outputElement.querySelector(".stock-in").classList.add("hidden");
      self.outputElement.querySelector(".online-only").classList.add("hidden");
      self.outputElement.querySelector(".sold-out").classList.add("hidden");

      if (eastStock[0] === true) {
        self.outputElement.querySelector(".stock-in").classList.remove("hidden");
      } else if (oxfordStock[0] === true && eastStock[0] !== true) {
        self.outputElement.querySelector(".online-only").classList.remove("hidden");
      } else if (oxfordStock[0] !== true && eastStock[0] !== true) {
        self.outputElement.querySelector(".sold-out").classList.remove("hidden");
      } else {
        // do nothing
      }
      
 //      if (outOfStock.indexOf(true) > -1) {
 //    	  // Loop through response
 //    	  for (var i = 0; i < stockCount; i++) {
 //          if (stockLevelData[i].name.indexOf("East") > -1 || stockLevelData[i].name.indexOf("Brick") > -1) {
 //            if (stockLevelData[i].available == true) {
 //                self.outputElement.querySelector(".stock-in").classList.remove("hidden");
 //                self.outputElement.querySelector(".stock-out").classList.add("hidden");
 //            } else {
 //                self.outputElement.querySelector(".stock-out").classList.remove("hidden");
 //                self.outputElement.querySelector(".stock-in").classList.add("hidden");
 //            }
 //          }
 //          if (stockLevelData[i].name.indexOf("North") > -1 || stockLevelData[i].name.indexOf("Oxford") > -1) {
 //            if (stockLevelData[i].available == true) {
 //                self.outputElement.querySelector(".stock-in").classList.remove("hidden");
 //                self.outputElement.querySelector(".stock-out").classList.add("hidden");
 //            } else {
 //                self.outputElement.querySelector(".stock-out").classList.remove("hidden");
 //                self.outputElement.querySelector(".stock-in").classList.add("hidden");
 //            }
 //          }
 //        }
 //      } else {
 //        self.outputElement.classList.remove("hidden");
 //        self.outputElement.querySelector(".stock-loading").classList.add("hidden");
 //        self.outputElement.querySelector(".stock-error").classList.add("hidden");
 //        self.outputElement.querySelector(".stock-in").classList.add("hidden");
 //        self.outputElement.querySelector(".sold-out").classList.remove("hidden");
 //      }
	}
}

/* Init */
var stockCheckLink = document.getElementById("checkStockLink");
var stockCheckOutput = document.getElementById("checkStockOutput");
var stockChecker = new StockChecker(stockCheckOutput);

stockCheckLink.addEventListener("click", function(e) {
    e.preventDefault();
    var variantElement = document.querySelector('.product-template__container input[name="id"]:checked') || document.querySelector('.product-template__container input[name="id"]');
  
  if (variantElement === null) {
    variantElement = document.querySelector('.product-template__container input[name="items[0]id"]:checked') || document.querySelector('.product-template__container input[name="items[0]id"]');
  }
    stockChecker.getInventoryIdForVariant(variantElement);
});
